import emit from '../../../common/events';
import { StoreState } from '../../../store/store.interface';
import { getUserDataForUserAnalytics } from '../../user-profile/user-profile.selectors';
import { getCartAnalyticsOverrides } from '../../cart/shop-cart/shop-cart.analytics';

export class GooglePayButtonAnalytics {
  startEvent(state: StoreState, element: Element, amount: string) {
    emit({
      element,
      name: `mhecomm-google-pay-checkout-start`,
      detail: {
        label: 'Google Pay Checkout Start',
        url: window.location.href,
        user: getUserDataForUserAnalytics(state),
        orderTotal: parseFloat(amount),
        ...getCartAnalyticsOverrides(state),
      },
    });
  }

  checkoutInfoCollected(element: Element, paymentDetails, billingAddress, shippingAddress) {
    emit({
      element,
      name: `mhecomm-google-pay-checkout-info-collected`,
      detail: {
        billingAddress,
        paymentDetails,
        shippingAddress,
      }
    });
  }
}
